import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import sliceReducers from './slices';

export default history => (state, action) => {
  const appReducer = combineReducers({
    router: connectRouter(history),
    ...sliceReducers,
  });

  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js